import React from 'react';
import { Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const defWidth = '130px';
const defWidthWrapper = '175px';
const defHeight = '42px';
// const defHeightWrapper = '50px';

const DateInput = ({ value, onClick }) => {
  const valueText = value ?? "виберіть дату...";

  return (
    <InputGroup className="mb-3">
      <Form.Control
        placeholder={valueText}
        aria-label={valueText}
        aria-describedby="date-icon"
        onClick={onClick}
        style={{
          width: defWidth,
          minWidth: defWidth,
          maxWidth: defWidth,
          background: 'unset',
          height: defHeight,
          cursor: 'pointer',
        }}
        value={valueText}
        readOnly
      />
      <InputGroup.Text style={{ cursor: 'pointer' }} onClick={onClick} id="date-icon"><i className="bi bi-calendar"></i></InputGroup.Text>
    </InputGroup>
  );
}

const DatePickerSelect = ({ dateValue, onChange }) => {
  return (
    <div
      style={{
        width: defWidthWrapper, minWidth: defWidthWrapper, maxWidth: defWidthWrapper, height: defHeight
      }} >
      <DatePicker
        selected={dateValue}
        onChange={onChange}
        dateFormat="dd.MM.yyyy"
        customInput={<DateInput dateValue={dateValue} />}
        style={{ width: defWidth, minWidth: defWidth, maxWidth: defWidth }}
        onKeyDown={(e) => e.preventDefault()}
      />
    </div >
  );
};

export default DatePickerSelect;